/**
 * Query keys para el dominio de perfil de usuario.
 *
 * @remarks
 * El perfil es user-scoped, no org-scoped — no requiere orgId en la key.
 */
export const PROFILE_KEYS = {
  all: ['profile'] as const,
  me: () => ['profile', 'me'] as const,
} as const;
